import React from 'react';
import PropTypes from 'prop-types';
import css from './PreferenceSwitch.scss';
import Switch from 'common/Switch';

/**
 * @returns {node} a custom accessible switch component.
 */
const PreferenceSwitch = ({ ariaLabel, checked, disabled, onChange }) => {
    return <Switch aria-label={ariaLabel} 
                   checked={checked}
                   disabled={disabled}
                   extraCss={css['preference-switch']}
                   onChange={onChange} />
};

PreferenceSwitch.defaultProps = {
    disabled: true
};

PreferenceSwitch.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

export default PreferenceSwitch;
